module.exports = __webpack_public_path__ + "img/blog-cv-3.222b9ee3.webp";